__turbopack_context__.v({
  "loader": "Loader-module__dPVPHW__loader",
  "rotation": "Loader-module__dPVPHW__rotation",
});
